import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { TokenService } from './token.service';
import { AlertServiceService } from './alert-service.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private walletBalanceSubject = new BehaviorSubject<number>(0);
  walletBalance$ = this.walletBalanceSubject.asObservable();
  constructor(
    private http: HttpClient,
    private router: Router,
    private tokenService: TokenService,
    private as: AlertServiceService
  ) { }
  setBalance(balance: number) {
    this.walletBalanceSubject.next(balance);
  }
  fetchTransactions() {
    return this.http.get(`${environment.url}/transaction/getList`)
  }
  getPaymentById(id: string) {
    return this.http.get(`${environment.url}/transaction/getDataById`, {
      params: { id }
    });
  }
  fetchPendingBills() {
    return this.http.get(`${environment.url}/wallet/pendingbills`)
  }
  fetchAgents() {
    return this.http.get(`${environment.url}/agents/getList`)
  }
  fetchAgentsByArea(area: string) {
    return this.http.get(`${environment.url}/agents/getListByArea`, {
      params: { area }
    });
  }
  getBalance(id:any) {
    return this.http.get(`${environment.url}/wallet/getDataById`, {
      params: { id }
    })
  }
  getService() {
    return this.http.get(`${environment.url}/service/getList`).toPromise();
  }
  getAllotment(params?: any) {
    return this.http.get(`${environment.url}/allocation/getList`, {
      params: params || {}
    });
  }
  getAllotments() {
    return this.http.get(`${environment.url}/allocation/getList`).toPromise();
  }
  createAllotment(data: any) {
    return this.http.post(`${environment.url}/allocation/create`, data);
  }
  createDistributor(data: any) {
    return this.http.post(`${environment.url}/user/create`, data);
  }
  userList(f: any) {
    return this.http.get(`${environment.url}/user/getList`, {
      params: f || {}
    });
  }
  createAgent(data: any) {
    return this.http.post(`${environment.url}/agents/create`, data);
  }
  createCustomer(data: any) {
    return this.http.post(`${environment.url}/customer/create`, data);
  }
  getCustomerById(id: string) {
    return this.http.get(`${environment.url}/customer/getDataById`, {
      params: { id }
    });
  }
  updateCustomerById(id: string, data: any) {
    return this.http.put(`${environment.url}/customer/updateById`, data, {
      params: { id }
    });
  }
  getAgentById(id: string) {
    return this.http.get(`${environment.url}/agents/getDataByIdN`, {
      params: { id }
    });
  }
  createProduct(data: any) {
    return this.http.post(`${environment.url}/product/create`, data);
  }
  createAlacarte(data: any) {
    return this.http.post(`${environment.url}/alacarte/create`, data);
  }
  listAlacarte() {
    return this.http.get(`${environment.url}/alacarte/getlist`);
  }
  getAlacarteById(id: string) {
    return this.http.get(`${environment.url}/alacarte/getDataById`, {
      params: { id }
    });
  }
  updateAlacarteById(id: string, data: any) {
    return this.http.put(`${environment.url}/alacarte/updateById`, data, {
      params: { id }
    });
  }
  updateProductById(id: string, data: any) {
    return this.http.put(`${environment.url}/product/updateById`, data, {
      params: { id }
    });
  }
  getProductById(id: string) {
    return this.http.get(`${environment.url}/product/getDataById`, {
      params: { id }
    });
  }
  getCustomerList(query?: any) {
    return this.http.get(`${environment.url}/customer/getList`, {
      params: query || {}
    });
  }
  getProductList() {
    return this.http.get(`${environment.url}/product/getList`)
  }
  dashboardCount() {
    return this.http.get(`${environment.url}/ds/dashboard`)
  }
  analysisCount() {
    return this.http.get(`${environment.url}/ds/analysis`)
  }
  getUserData() {
    return this.http.get(`${environment.url}/user/getDataById`)
  }
  getUpdateUserData() {
    return this.http.get(`${environment.url}/user/getDataById`)
  }
  getRole() {
    return this.http.get(`${environment.url}/user/getRole`)
  }
  getRoleToPromise() {
    return this.http.get(`${environment.url}/role/getlist`).toPromise();
  }
  collectCash(data: any) {
    return this.http.post(`${environment.url}/wallet/cashBalance`, data);
  }
  intiatePaymentLink(data: any) {
    return this.http.post(`${environment.url}/transaction/intiatePaymentLink`, data);
  }
  resendCustomerBill(data: any) {
    return this.http.post(`${environment.url}/transaction/resendBill`, data);
  }
  cashSubmission(data: any) {
    return this.http.post(`${environment.url}/wallet/cashSubmission`, data);
  }
  updateCashSubmission(data: any) {
    return this.http.post(`${environment.url}/wallet/updateCashSubmissionReq`, data);
  }
  cashSubmissionReqList(filterParams?: any) {
    return this.http.get(`${environment.url}/wallet/cashSubmissionReqList`, {
      params: filterParams || {}
    });
  }
  getNotifications() {
    return this.http.get(`${environment.url}/notification/getCount`);
  }
  getNotificationsList() {
    return this.http.get(`${environment.url}/notification/getList`);
  }
  createTermsAndConditions(data: any) {
    return this.http.post(`${environment.url}/terms/create`, data);
  }
  listTermsAndConditions() {
    return this.http.get(`${environment.url}/terms/create`);
  }
  getInvoiceByPaymentId(id: any) {
    return this.http.get(`${environment.url}/transaction/getInvoiceById`, {
      params: { id }
    });
  }
  getBillingList(params?: any) {
    return this.http.get(`${environment.url}/transaction/getBillingList`, { params });
  }
  getSettlementList(params?: any) {
    return this.http.get(`${environment.url}/transaction/getSettlementList`, { params });
  }
}